// import Select from "react-select";
import makeAnimated from "react-select/animated";
import { components } from 'react-select';

// import AsyncSelect from 'react-select/async';
import { useState, useEffect } from "react";
// import { getLevelThreeNestedData, getTagProperties } from "../../../utils/getNestedData"
import { findNonAssociatedElements } from "@/utils/frontend/associationOps";

import { humanizeString } from "@/utils/frontend/stringOps";
import useSelectStyles from "./Styles";
import dynamic from "next/dynamic";
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";

const Select = dynamic(() => import("react-select"), {
  ssr: false,
});

const UsersAssociationSelect = ({ callback, tagsTable, tagsLevel, zIndex, target, placeholder, isMulti=true, selectedParent, selectedParentTag, state, lang, presetUsers }) => {
  console.log('PRESETUSERS', presetUsers)
  // presetTopics is called from /feed/topics/Sourcing for example, this way the user has to have it included in the NewSocialPostCard when making a new post in that topic page.
  // Right now, presetTopics is one single obj, not an array


    const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned, setError, setSuccess, hint, setHint } = useContext(UIContext);


  // console.log("TARGET@TagsAssociationSelect", target)
    //  console.log('tagstable,', tagsTable)
  const animatedComponents = makeAnimated();

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRtl, setIsRtl] = useState(false);
  const [selectedTags, setSelectedTags] = useState();
  const [associatedTags, setAssociatedTags] = useState();
 

  // populate associatedTags with presetTopics if there are any, used in feed/topics/topicName
  useEffect(() => {
    if (presetUsers){
      setIsClearable(false)
      // setIsClearable(false)
      const mappedUsers = presetUsers.map(u => {return {
        ...u,
        // label: `${u.user_first_name} ${u.user_last_name}`,
        label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,

        isFixed: true
      }})
      setAssociatedTags([...mappedUsers])
      // setAssociatedTags({...presetUsers, label: `${presetUsers.user_first_name} ${presetUsers.user_last_name}`, label_en: presetUsers.topic_name_en, topic_level: presetUsers.topic_level, user_uuid: presetUsers.user_uuid, value: presetUsers.topic_name_en, isFixed:true})
      // callback({'lvlOne': {newTags: [{...presetUsers}]}});
    }
  }, [presetUsers])
  
  // console.log("SelectedParent", selectedParent)
  useEffect(() => {


    // if (target && target.tag) {
    //   // console.log('tarTAgs', target.tags)
    //   let tagsAssociated = [];
   
    //     tagsAssociated.push({ value: target.tag.topic_name_en, label: target.tag.topic_name_en, topic_name_en: target.tag.topic_name_en, tag_name_fr: target.tag.tag_name_fr, topic_level: target.tag.topic_level, topic_colors: target.tag.topic_colors, tag_id: target.tag.tag_id, topic_uuid: target.tag.topic_uuid });

    //   setAssociatedTags(tagsAssociated);
    // }





        if (target && target.topics) {
      // console.log('tarTAgs', target.tags)
      let tagsAssociated = [];
      for (let tag of target.topics) {
        if (tag.topic_level === tagsLevel){tagsAssociated.push({ value: tag.topic_name_en, label: tag.topic_name_en, topic_name_en: tag.topic_name_en, topic_name_fr: tag.topic_name_fr, topic_level: tag.topic_level, topic_colors: tag.topic_colors, tag_id: tag.id, uuid: tag.uuid, 

          // tag_snapshot: { //this here is only used for JobPreviewCard
          //   value: tag.tag_snapshot.topic_name_en, label: tag.tag_snapshot.topic_name_en, topic_name_en: tag.tag_snapshot.topic_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, topic_level: tag.tag_snapshot.topic_level, topic_colors: tag.tag_snapshot.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid,
          // }
         });}
      }
      setAssociatedTags(tagsAssociated);
    }



    // uncomment if above go wrong
    // if (target && target.tags) {
    //   // console.log('tarTAgs', target.tags)
    //   let tagsAssociated = [];
    //   for (let tag of target.tags) {
    //     if (tag.tag_snapshot.topic_level === tagsLevel){tagsAssociated.push({ value: tag.tag_snapshot.topic_name_en, label: tag.tag_snapshot.topic_name_en, topic_name_en: tag.tag_snapshot.topic_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, topic_level: tag.tag_snapshot.topic_level, topic_colors: tag.tag_snapshot.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid, 

    //       tag_snapshot: { //this here is only used for JobPreviewCard
    //         value: tag.tag_snapshot.topic_name_en, label: tag.tag_snapshot.topic_name_en, topic_name_en: tag.tag_snapshot.topic_name_en, tag_name_fr: tag.tag_snapshot.tag_name_fr, topic_level: tag.tag_snapshot.topic_level, topic_colors: tag.tag_snapshot.topic_colors, tag_id: tag.tag_id, topic_uuid: tag.topic_uuid,
    //       }
    //      });}
    //   }
    //   setAssociatedTags(tagsAssociated);
    // }

    const getData = async () => {

      try {
        // Only display division (selectedParent) relevant tags 
        // if (Number(selectedParent)){
        // tagsTable = await tagsTable.filter(tag=> tag.tag_sector_industry.id === selectedParent || tag.tag_sector_industry.id === 0)
        // }
        // else {
        //   tagsTable = []
        // }

        let tagMenuOptions = tagsTable?.filter((tag) => {
           // if tagsLevel is passed as an argument, filter tags to match tagsLevel, otherwise, return all tags
          if (tagsLevel) {
            return tag.topic_level === tagsLevel
          } else {
            return tag
          }}).map((tag) => {
            return {
              // key: tag.tag_snapshot.topic_name_en,
              // id: tag.id,
              user_uuid: tag.user_uuid,
              user_handle: tag.user_handle,
              value: tag.user_uuid,
              label: `@${tag.user_handle} (${tag.user_first_name} ${tag.user_last_name})`,

              // tag_snapshot: { // only used for JobPreviewCard, just like the redundancy above         
              //   // id: tag.id,
              // value: tag.topic_name_en,
              // label: tag.topic_name_en,
              // topic_name_en: tag.topic_name_en,
              // tag_name_fr: tag.tag_name_fr,
              // topic_level: tag.topic_level,
              // topic_colors: tag.topic_colors,
              // topic_uuid: tag.topic_uuid,}
            };
          });
          setData(await tagMenuOptions);
 


        
        // console.log("SELPAR", selectedParent)
        // if (selectedParent === 'FINANCE') { 
        //   // console.log("HERE")
        //   // tagMenuOptions = await tagMenuOptions.filter(tag=>tag.tag_sector_industry.id === 2)
        //   setData(await tagMenuOptions)
        // }
      } catch (error) {
        console.log("error", error);
      }

    };

    getData();



  }, [target, tagsTable, selectedTags, selectedParent]);

  const handleChange = async (newRecords) => {

    let totalLevel1Tags = Array.isArray(newRecords) ? newRecords.filter(tag=>tag.topic_level === 1).length : 0
    if (totalLevel1Tags > 2) {
      // alert('3 Tags Max');
      setError({message: 'You can select up to 2 topics per post'})
      return false;
    }

    // if more than 3 level 2 tags are selected, don't add any more tags and raise an alert
    let totalLevel2Tags = Array.isArray(newRecords) ? newRecords.filter(tag=>tag.topic_level === 2).length : 0
    if (totalLevel2Tags > 3) {
      // alert('3 Tags Max');
           setError({message: 'You can select up to 2 sub-topics per post'})

      return false;
    }
    setSelectedTags({ ...selectedTags, newRecords });
    // setSelectedTags(selectedTags => [...selectedTags, ...newTags]);
    console.log('selectedTags@TagsAssociationSelect', selectedTags)
    // await callback({[tagsLevel === 1 ? 'lvlOne' : tagsLevel === 2 ? 'lvlTwo' : 'lvlThree' || 'tags']: {...selectedTags, newTags }});

    await callback({['selectedUsers']: {...selectedTags, newRecords }});


  };

//   const getValue = () => {
//      return target?.tags.map(tag => {return {value: 's', label: 's'}})
//   }
// target?.tags.map(tag => {return {value: tag.topic_name_en, label: tag.topic_name_en}}
  
const MultiValueRemove = (props) => {
  if (props.data.isFixed) {
    return null;
  }
  return <components.MultiValueRemove {...props} />;
};

return (
    <>



      <Select
        isMulti={isMulti}
        className="font-inter text-base font-normal"
        // className={`
        // dark:bg-inherit appearance-none inner-shadow rounded px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start bg-inherit`}
        
        classNamePrefix="select"
        value={selectedTags ? selectedTags.newTags : associatedTags}
        isDisabled={isDisabled || presetUsers?.length> 0}
        isLoading={isLoading}
        isClearable={isClearable}
        isRtl={isRtl}
        isSearchable={isSearchable}
        name="userSelect"
        id="userSelect"
        onChange={(tag) => {
          handleChange(tag);
        }}
        
        // value={value}
        options={data}
        components={{MultiValueRemove}}
        menuPlacement="bottom"
        styles={useSelectStyles(null, null, 'TOPICS')}
        placeholder={placeholder}
      />

      {/*
          <div
            style={{
              color: 'hsl(0, 0%, 40%)',
              display: 'inline-block',
              fontSize: 12,
              fontStyle: 'italic',
              marginTop: '1em',
            }}
          >
            <Checkbox
              checked={isClearable}
              onChange={() => setIsClearable((state) => !state)}
            >
              Clearable
            </Checkbox>
            <Checkbox
              checked={isSearchable}
              onChange={() => setIsSearchable((state) => !state)}
            >
              Searchable
            </Checkbox>
            <Checkbox
              checked={isDisabled}
              onChange={() => setIsDisabled((state) => !state)}
            >
              Disabled
            </Checkbox>
            <Checkbox
              checked={isLoading}
              onChange={() => setIsLoading((state) => !state)}
            >
              Loading
            </Checkbox>
            <Checkbox checked={isRtl} onChange={() => setIsRtl((state) => !state)}>
              RTL
            </Checkbox> 
          </div>
          */}
    </>
    //      <>

    // <Select className="w-full mb-4 shadow appearance-none border rounded py-2 px-3 mx-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start"
    // closeMenuOnSelect={false}
    // components={animatedComponents}
    // // defaultValue={[options[4], options[5]]}
    // isMulti
    // options={data}
    // />
    // </>
  );
};

export default UsersAssociationSelect;
